import * as React from "react";

export interface UIContextProps {
  sidebar: boolean;
  setSidebar: (sidebar: boolean) => void;
  rightSidebar: boolean;
  setRightSidebar: (rightSidebar: boolean) => void;
  chatTitle: string;
  setChatTitle: (title: string) => void;
}

export const UIContext = React.createContext<UIContextProps>({
  sidebar: false,
  setSidebar: () => {},
  rightSidebar: false,
  setRightSidebar: () => {},
  chatTitle: "",
  setChatTitle: () => {},
});
